// app/javascript/packs/components/GeojsonFilter.jsx

import React, {useState, useEffect, useRef} from 'react';
import {Block, FormGroup, Map} from '../components';
import {Badge, Button, Col, Row} from "react-bootstrap";
import {IsJsonValid, usePrevious} from "../utils";
import geojsonhint from "@mapbox/geojsonhint";
import { GeoJSONRewind } from '../../services/GeoJSONRewind';
import { omit } from 'lodash';

function GeojsonFilterForm({value, onChange, ...props}) {
  const [lastValidGeojson, setLastValidGeojson] = useState({});
  const [stringifiedGeojson, setStringifiedGeojson] = useState("");
  const inputRef = useRef(null);
  const [cursor, setCursor] = useState(0);
  const [geojsonErrors, setGeojsonErrors] = useState([]);
  const addTab = useRef(false);

  const stringify = (json) => {
    if (Array.isArray(json) && json.length === 0) {
      return ""
    } else if (json) {
      return JSON.stringify(json, undefined, 4)
    }  else {
      return ""
    }
  }

  const geoJsonify = (value) => {
    if ( typeof value === 'string' && value !== null && IsJsonValid(value) ) {
      return JSON.parse(value)
    } else {
      return value
    }
  }

  const refreshText = (string) => {
    setStringifiedGeojson(string);
    const errors = geojsonhint.hint(string);
    setGeojsonErrors(errors.map((e) => e.message))
    if (errors.length === 0) {
      onChange(geoJsonify(string))
    }
  }

  const handleTextChange = (event) =>{
    let string = event.target.value;
    refreshText(string)
  }

  const handleMapChange = (data) =>{
    if (typeof data === 'object' && data !== null && !( data instanceof Array) ) {
      setLastValidGeojson(data);
      onChange(data);
    }
  }

  const handleTabInsert = (event) => {
    const { selectionStart, selectionEnd } = event.target;
    if (event.keyCode === 9) {
      event.preventDefault();
      const val = stringifiedGeojson;
      addTab.current = true;
      setStringifiedGeojson(val.substring(0, selectionStart) + '\t' + val.substring(selectionEnd))
      setCursor( selectionStart + 1);
    }
  }

  useEffect(() => {
    setStringifiedGeojson(stringify(value));
    setLastValidGeojson(geoJsonify(value));
  }, [value])

  useEffect(() => {
    if (addTab.current) {
      addTab.current = false;
      inputRef.current.selectionStart = cursor;
      inputRef.current.selectionEnd = cursor;
    }
  }, [stringifiedGeojson])

  const heightStyle = {
    height: '500px',
    marginBottom: '30px'
  }

  const isNotRightHand = () => (geojsonErrors.find((e)=>(e == "Polygons and MultiPolygons should follow the right-hand rule" )))

  const hasCRS = () => (geojsonErrors.find((e)=>(e.match(/^old-style crs/))))

  const canBeFixed = () =>( isNotRightHand() || hasCRS() )

  const fixRightHand = (json) => {
    if ( isNotRightHand() ) {
      return (new GeoJSONRewind()).rewind(json)
    }
    return json
  }

  const removeCRS = (json) => {
    if ( hasCRS() ) {
      return omit(json, "crs")
    }
    return json
  }

  const fixGeojson = () => {
    let transformed = JSON.parse(stringifiedGeojson)
    transformed = fixRightHand(transformed)
    transformed = removeCRS(transformed)
    refreshText(stringify(transformed))
  }

  return (
    <Row>
      <Block as={Col} md={12} lg={6} fullHeight style={heightStyle}>
        <FormGroup
          label={<>Geojson {canBeFixed() && <a className="float-right" onClick={fixGeojson}><Badge bg="secondary">Fix</Badge></a>} </>}
          input="textarea"
          ref={inputRef }
          inputStyle={{flex: 1}}
          style={{display: "flex", flexDirection: "column"}}
          onKeyDown={handleTabInsert}
          errors={geojsonErrors}
          isInvalid={geojsonErrors.length > 0}
          {...props}
          value={stringifiedGeojson}
          onChange={handleTextChange}
        />
      </Block>
      <Col md={12} lg={6} style={heightStyle}>
        <Map
          geojson={lastValidGeojson}
          onChange={handleMapChange}
          draw={true}
          disabled={props.disabled}
        />
      </Col>
    </Row>
  )
}

export default GeojsonFilterForm

GeojsonFilterForm.propTypes = {

}
